import { createSlice } from '@reduxjs/toolkit';

import {
  ListByVehicleResponse,
  MontlyRateCalculationPayload,
  MontlyRateCalculationPayloadReduced,
  MontlyRateCalculationResponse
} from '../_declarations/target';
import {
  listByVehicleApi,
  montlyRateCalculationApi,
  retrieveQuotationIdData
} from '../api/financialCalculator';

interface FinancialCalculatorState {
  listByVehicle?: ListByVehicleResponse;
  montlyRateCalculation?: {
    [key: string]: MontlyRateCalculationResponse | string;
  };
  montlyRateCalculationPayloads?: {
    [key: string]: MontlyRateCalculationPayload;
  };
  quotationLoading?: boolean;
}

const initialState: FinancialCalculatorState = {
  quotationLoading: true
};

const financialCalculatorSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(listByVehicleApi.fulfilled, (state, action) => {
        state.listByVehicle = action.payload;
      })
      .addCase(montlyRateCalculationApi.pending, (state, action) => {
        const ma = (action?.meta.arg as MontlyRateCalculationPayloadReduced)
          .masterAgreement;

        if (ma) {
          state.montlyRateCalculation = {
            ...state.montlyRateCalculation,
            [ma]: 'loading'
          };
        }
      })
      .addCase(montlyRateCalculationApi.rejected, (state, action) => {
        const ma = (action?.meta.arg as MontlyRateCalculationPayloadReduced)
          .masterAgreement;

        if (ma) {
          state.montlyRateCalculation = {
            ...state.montlyRateCalculation,
            [ma]: 'rejected'
          };
        }
      })
      .addCase(montlyRateCalculationApi.fulfilled, (state, action) => {
        state.montlyRateCalculation = {
          ...state.montlyRateCalculation,
          [action.payload.masterAgreement]: action.payload.response
        };

        state.montlyRateCalculationPayloads = {
          ...state.montlyRateCalculationPayloads,
          [action.payload.masterAgreement]: action.payload.apiPayload
        };
      })
      .addCase(retrieveQuotationIdData.fulfilled, (state, action) => {
        const { regularPayment, ...rest } = action.payload;

        const {
          widgetSelection: {
            parameters: { masterAgreement }
          }
        } = rest;

        state.montlyRateCalculation = {
          ...state.montlyRateCalculation,
          [masterAgreement]: { regularPayment }
        };

        state.montlyRateCalculationPayloads = {
          ...state.montlyRateCalculationPayloads,
          [masterAgreement]: rest
        };

        state.quotationLoading = false;
      });
  },
  initialState,
  name: 'financialCalculator',
  reducers: {
    setQuotationLoading: (state, action) => {
      state.quotationLoading = action.payload;
    }
  }
});

export const { setQuotationLoading } = financialCalculatorSlice.actions;
export default financialCalculatorSlice.reducer;
